import { roles } from "../config/config";

export const warehousePermissions = [
  roles.admin,
  roles.gestore,
  roles.developer,
  roles.magazziniere,
  roles.grafico,
];

export const warehouseItemPermissions = [
  roles.admin,
  roles.gestore,
  roles.developer,
  roles.grafico,
  roles.magazziniere,
];
